import { __assign } from "tslib";
import { Models } from '@/setup/models/ModelProvider';
import GlobalConfigs from '@/setup/GlobalConfigs/GlobalConfigs';
import LoadingConfig from '@/setup/fullLoading/fullLoadingConfig';
import { Links } from '@/setup/router/links';
export default __assign({
  Links: Links,
  GlobalConfigs: GlobalConfigs,
  LoadingConfig: LoadingConfig
}, Models);